export default __webpack_public_path__ + "static/media/audited-by-certik.75c189ce.svg";